import React from 'react';
import type { FC } from 'react';

import { Label, type LabelKind } from '@admin/components/helpers/label';
import { Vehicle__Status, type Vehicle } from '@admin/schema';

const KINDS: Record<Vehicle__Status, LabelKind> = {
  [Vehicle__Status.Active]: 'success',
  [Vehicle__Status.Inactive]: 'default',
  [Vehicle__Status.Grounded]: 'warning',
  [Vehicle__Status.Management]: 'purple',
  [Vehicle__Status.Excess]: 'dark',
};

const NAMES: Record<Vehicle__Status, string> = {
  [Vehicle__Status.Active]: 'Active',
  [Vehicle__Status.Inactive]: 'Inactive',
  [Vehicle__Status.Grounded]: 'Grounded',
  [Vehicle__Status.Management]: 'Management',
  [Vehicle__Status.Excess]: 'Excess',
};

export const VehicleStatusLabel: FC<{ vehicle: Pick<Vehicle, 'status'> }> = ({ vehicle }) => (
  <Label kind={KINDS[vehicle.status]}>{NAMES[vehicle.status]}</Label>
);
